import {
  DadosAtualizarCadastrarFeriado,
  Feriado,
} from "../model/entities/Feriado";
import api from "./api";

const ROUTE = "feriado";

class feriadoApi {
  async getById(id: number) {
    try {
      const res = await api.get<Feriado>(`/${ROUTE}/${id}`);
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
  async getMany(pagina: number, linhasPorPagina: number) {
    try {
      const res = await api.get<Feriado[]>(
        `/${ROUTE}?size=${linhasPorPagina}&page=${pagina}`
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async getManyComplete() {
    try {
      const res = await api.get<Feriado[]>(`/${ROUTE}/complete`);
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async insert(dados: DadosAtualizarCadastrarFeriado) {
    try {
      const res = await api.post<any>(`/${ROUTE}`, dados);
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async count() {
    try {
      const res = await api.get<number>(`/${ROUTE}/count`);
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async update(
    idAgendamento: number,
    agendamento: DadosAtualizarCadastrarFeriado
  ) {
    try {
      const res = await api.put<Feriado>(
        `/${ROUTE}/${idAgendamento}`,
        agendamento
      );
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async delete(id: number) {
    try {
      const res = await api.delete<Feriado>(`/${ROUTE}/${id}`);
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
}

const apiFeriado = new feriadoApi();
export default apiFeriado;
